<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="24">
        <el-form-item
          :label="cardLabel"
        >
          <el-card>
            <slot name="beforeSetting"></slot>
            <el-row :gutter="20"
              v-show="showSetting"
            >
              <el-col :xs="24">
                <div class="el-form-item__content">
                  <el-form-item
                    :label="$t('api.product.fields.cancel_rule.setting_label')"
                    :rules="cancelRuleModeRules"
                    prop="cancelRuleMode"
                  >
                    <el-radio-group
                      v-model="cancelRule.mode"
                      @mousedown.native="isClickingRadio = true"
                      @mouseup.native="isClickingRadio = false"
                    >
                      <el-radio
                        :label="CancelRuleMode.BookingTime"
                        border
                        :disabled="formData.setting.payment_mode !== ProductPaymentMode.Onsite"
                      >
                        {{ $t('api.product.fields.cancel_rule.mode.booking_time') }}
                      </el-radio>
                      <el-radio :label="CancelRuleMode.Hour" border>
                        {{ $t('api.product.fields.cancel_rule.mode.hour') }}
                      </el-radio>
                      <el-radio :label="CancelRuleMode.Day" border>
                        {{ $t('api.product.fields.cancel_rule.mode.day') }}
                      </el-radio>
                      <el-radio :label="CancelRuleMode.Date" border>
                        {{ $t('api.product.fields.cancel_rule.mode.date') }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </el-col>
              <el-col v-if="!limitOne">
                <el-button
                  icon="el-icon-plus"
                  @click="onAdd"
                >
                  {{ $t('api.product.fields.cancel_rule.add_rule') }}
                </el-button>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('api.product.fields.cancel_rule.check_rule_desc')"
                  placement="top-start"
                >
                  <el-button
                    icon="el-icon-sort"
                    @click="onSort"
                  >
                    {{ $t('api.product.fields.cancel_rule.check_rule') }}
                  </el-button>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row
              v-if="limitOne && showSetting && isNoShowPenalty"
              :gutter="10"
            >
              <el-col :md="24">
                <el-divider class="rules"></el-divider>
              </el-col>
              <el-row v-if="cancelRule.mode === CancelRuleMode.BookingTime">
                <el-col :md="8" align="right">
                  {{ getKey(0) }}
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col :md="6" align="right">
                  {{ getKey(0) }}
                </el-col>
                <el-col :md="6">
                  <el-input
                    v-if="cancelRule.mode === CancelRuleMode.Day"
                    v-model.number="cancelRule.rules[0].day"
                    type="number"
                    @blur="(e) => onBlur(e, 'day', 0)"
                    @keypress.native="ignoreDot"
                  >
                  </el-input>
                  <el-input
                    v-else-if="cancelRule.mode === CancelRuleMode.Hour"
                    v-model.number="cancelRule.rules[0].hour"
                    type="number"
                    @blur="(e) => onBlur(e, 'hour', 0)"
                    @keypress.native="ignoreDot"
                  >
                  </el-input>
                  <el-date-picker
                    v-else-if="cancelRule.mode === CancelRuleMode.Date"
                    v-model="cancelRule.rules[0].date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('api.product.fields.cancel_rule.day0')"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :md="12" align="left">
                  {{ getKey(1) }}
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="14" align="right">
                  {{ getKey(0, 'amount') }} {{ formData.currency_code }}
                </el-col>
                <el-col :md="4">
                  <el-input
                    v-model.number="cancelRule.rules[0].deposit_amount"
                    type="number"
                    :min="0"
                    @blur="(e) => onBlur(e, 'deposit_amount', 0)"
                  >
                  </el-input>
                </el-col>
                <el-col :md="6" align="left">
                  {{ getKey(1, 'amount') }}
                </el-col>
              </el-row>
            </el-row>
            <el-row
              v-else-if="limitOne && showSetting"
              :gutter="10"
            >
              <el-col :md="24">
                <el-divider class="rules"></el-divider>
              </el-col>
              <el-row v-if="cancelRule.mode === CancelRuleMode.BookingTime">
                <el-col :md="8" align="right">
                  {{ getKey(0) }}
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col :md="6" align="right">
                  {{ getKey(0) }}
                </el-col>
                <el-col :md="7">
                  <el-input
                    v-if="cancelRule.mode === CancelRuleMode.Day"
                    v-model.number="cancelRule.rules[0].day"
                    type="number"
                    min="0"
                    @blur="(e) => onBlur(e, 'day', 0)"
                    @keypress.native="ignoreDot"
                  >
                  </el-input>
                  <el-input
                    v-else-if="cancelRule.mode === CancelRuleMode.Hour"
                    v-model.number="cancelRule.rules[0].hour"
                    type="number"
                    min="0"
                    @blur="(e) => onBlur(e, 'hour', 0)"
                    @keypress.native="ignoreDot"
                  >
                  </el-input>
                  <el-date-picker
                    v-else
                    v-model="cancelRule.rules[0].date"
                    type="date"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-col>
                <el-col :md="9">
                  {{ getKey(1) }}
                </el-col>
              </el-row>
            </el-row>
            <el-row
              v-else-if="showSetting"
              :gutter="10"
              v-for="(r, idx) in cancelRule.rules"
              :key="idx"
            >
              <el-col :md="24">
                <el-divider class="rules"></el-divider>
              </el-col>
              <el-col :md="6" align="right">
                {{ getKey(0) }}
              </el-col>
              <el-col :md="7">
                <el-input
                  v-if="cancelRule.mode === CancelRuleMode.Day"
                  v-model.number="r.day"
                  type="number"
                  @blur="(e) => onBlur(e, 'day', idx)"
                  @keypress.native="ignoreDot"
                  :disabled="idx === cancelRule.rules.length - 1 && r.day === 0"
                >
                </el-input>
                <el-input
                  v-else-if="cancelRule.mode === CancelRuleMode.Hour"
                  v-model.number="r.hour"
                  type="number"
                  @blur="(e) => onBlur(e, 'hour', idx)"
                  @keypress.native="ignoreDot"
                  :disabled="idx === cancelRule.rules.length - 1 && r.hour === 0"
                >
                </el-input>
                <el-date-picker
                  v-else
                  v-model="r.date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$t('api.product.fields.cancel_rule.day0')"
                  :disabled="idx === cancelRule.rules.length - 1 && isEmpty(r.date)"
                >
                </el-date-picker>
              </el-col>
              <el-col :md="9">
                {{ getKey(1) }}
              </el-col>
              <el-col :md="6" align="right">
                {{ getKey(0, 'amount') }}
              </el-col>
              <el-col :md="1">
                <el-checkbox
                  v-model="r.is_deposit_percent"
                  @change="(v, d) => onChangeDeposit(v, d, 'deposit_percent', idx)"
                >
                </el-checkbox>
              </el-col>
              <el-col :md="5">
                <el-input
                  v-model.number="r.deposit_percent"
                  :min="0"
                  :max="100"
                  type="number"
                  :disabled="!r.is_deposit_percent"
                  @blur="(e) => onBlur(e, 'deposit_percent', idx)"
                >
                </el-input>
              </el-col>
              <el-col :md="5">
                {{ $t('api.product.fields.cancel_rule.percent') }}
              </el-col>
              <el-col :md="7">
                {{ getKey(1, 'amount') }}
              </el-col>
              <el-col :span="6">
              </el-col>
              <el-col :md="1">
                <el-checkbox
                  v-model="r.is_deposit_amount"
                  @change="(v, d) => onChangeDeposit(v, d, 'deposit_amount', idx)"
                >
                </el-checkbox>
              </el-col>
              <el-col :md="2">
                {{ formData.currency_code }}
              </el-col>
              <el-col :md="5">
                <el-input
                  v-model.number="r.deposit_amount"
                  type="number"
                  :disabled="!r.is_deposit_amount"
                  @blur="(e) => onBlur(e, 'deposit_amount', idx)"
                >
                </el-input>
              </el-col>
              <el-col :md="10" align="right">
                <el-button
                  v-if="idx !== cancelRule.rules.length - 1"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="onDelete(idx)"
                >
                </el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ignoreDot } from '@/utils/number'
import { getTransText } from '@/utils/i18n'
import { getCurrencyMinAmount } from '@/utils/currencyMin'
import { ProductPaymentMode, CancelRuleMode } from '@/enums/product'

const defRule = {
  mode: 0,
  rules: [{
    day: 0,
    hour: 0,
    is_deposit_percent: true,
    deposit_percent: 100,
    is_deposit_amount: false,
    deposit_amount: 0
  }]
}

export default {
  name: 'cancel-setting',
  props: {
    formData: {
      type: Object,
      required: true
    },
    showSetting: {
      type: Boolean,
      required: true
    },
    limitOne: {
      type: Boolean,
      default: false
    },
    isFunBook: {
      type: Boolean,
      default: false
    },
    isNoShowPenalty: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cancelRule: defRule,
      isClickingRadio: false,
      ProductPaymentMode,
      CancelRuleMode
    }
  },
  computed: {
    cardLabel () {
      let prefix = (this.isFunBook) ? 'fb_cancel_rule' : 'cancel_rule'

      return this.$t(`api.product.fields.${prefix}.card_label`)
    },
    isRwg () {
      return this.formData.setting.rwg === 1
    },
    cancelRuleModeRules () {
      return [
        {
          validator: (rule, value, callback) => {
            if (this.isRwg && this.cancelRule.mode === CancelRuleMode.Date) {
              callback(this.getTransText('cancel_rule', 'error.cannot_select_date_in_rwg', 'product'))
              return
            }
            callback()
          },
          trigger: 'change'
        }
      ]
    },
    // Get minimum amount based on current product currency
    minDepositAmount () {
      return getCurrencyMinAmount(this.formData.currency_code)
    }
  },
  methods: {
    getTransText,
    ignoreDot,
    preset (setting) {
      this.cancelRule = JSON.parse(setting)
      if (typeof this.cancelRule.rules !== 'undefined') {
        for (let i = 0; i < this.cancelRule.rules.length; ++i) {
          if (typeof this.cancelRule.rules[i].deposit_percent !== 'undefined') {
            this.$set(this.cancelRule.rules[i], 'is_deposit_percent', true)
          }
          if (typeof this.cancelRule.rules[i].deposit_amount !== 'undefined') {
            this.$set(this.cancelRule.rules[i], 'is_deposit_amount', true)
          }
        }
      }
    },
    getModeKey (m) {
      switch (m) {
        case CancelRuleMode.Day:
          return 'day'
        case CancelRuleMode.Date:
          return 'date'
        case CancelRuleMode.Hour:
          return 'hour'
        case CancelRuleMode.BookingTime:
          return 'booking_time'
      }

      return 'day'
    },
    getKey (n, t) {
      let tmpl = this.getModeKey(this.cancelRule.mode)

      if (typeof t !== 'undefined') {
        tmpl = t
      }

      if (this.cancelRule.mode === CancelRuleMode.BookingTime && t === undefined) {
        return this.$t('api.product.fields.cancel_rule.tmpl.booking_time_available')
      }

      if (this.isNoShowPenalty) {
        tmpl = 'penalty.' + tmpl
      }

      if (this.limitOne) {
        tmpl = tmpl + '_available'
      }

      return this.$t('api.product.fields.cancel_rule.tmpl.' + tmpl).split('{{X}}')[n] || '　'
    },
    setDate (d) {
      return this.isEmpty(d) ? '9999-99-99' : d
    },
    isEmpty (d) {
      return (typeof d === 'undefined' || d === null || d === '')
    },
    apply (cancel) {
      this.cancelRule = JSON.parse(JSON.stringify(cancel))
    },
    leaveOneRule () {
      this.cancelRule.rules = this.cancelRule.rules.splice(-1, 1)
      if (this.cancelRule.rules[0].deposit_percent === undefined) {
        this.$set(this.cancelRule.rules[0], 'deposit_percent', 0)
      }
      if (this.cancelRule.rules[0].deposit_amount === undefined) {
        this.$set(this.cancelRule.rules[0], 'deposit_amount', 0)
      }
    },
    adjustRuleMode () {
      if (this.cancelRule.mode === CancelRuleMode.BookingTime) {
        this.cancelRule.mode = CancelRuleMode.Hour
      }
    },
    onSort () {
      this.cancelRule.rules = this.cancelRule.rules.sort(
        (a, b) => {
          switch (this.cancelRule.mode) {
            case CancelRuleMode.Day:
              if (a.day > b.day) {
                return -1
              }
              if (a.day < b.day) {
                return 1
              }
              break
            case CancelRuleMode.Date:
              let ea = this.setDate(a.date)
              let eb = this.setDate(b.date)
              if (ea > eb) {
                return 1
              }
              if (ea < eb) {
                return -1
              }
              break
            case CancelRuleMode.Hour:
              if (a.hour > b.hour) {
                return -1
              }
              if (a.hour < b.hour) {
                return 1
              }
              break
          }
          return 0
        }
      ).filter(
        (e, idx, arr) => {
          if (arr.length <= 1 || (idx === arr.length - 1)) {
            return true
          }
          switch (this.cancelRule.mode) {
            case CancelRuleMode.Day:
              return e.day !== arr[idx + 1].day
            case CancelRuleMode.Date:
              if (this.isEmpty(e.date) && this.isEmpty(arr[idx + 1].date)) {
                return false
              }
              return e.date !== arr[idx + 1].date
            case CancelRuleMode.Hour:
              return e.hour !== arr[idx + 1].hour
          }
        }
      )
    },
    onAdd () {
      if (this.cancelRule.rules.length > 0) {
        let r = JSON.parse(JSON.stringify(this.cancelRule.rules[0]))
        switch (this.cancelRule.mode) {
          case CancelRuleMode.Day:
            r.day = parseInt(r.day) + 1
            break
          case CancelRuleMode.Date:
            let d = this.$moment()
            if (r.date) {
              d = this.$moment(r.date, 'YYYY-MM-DD').add(-1, 'days')
            }
            r.date = d.format('YYYY-MM-DD')
            break
          case CancelRuleMode.Hour:
            r.hour = parseInt(r.hour) + 1
            break
        }
        this.cancelRule.rules.splice(0, 0, r)
      }
    },
    onDelete (idx) {
      this.cancelRule.rules.splice(idx, 1)
    },
    onChange () {
      for (let idx in this.cancelRule.rules) {
        let r = this.cancelRule.rules[idx]
        if (r.day === '' || r.hour === '' || r.deposit_percent === '' || r.deposit_amount === '') {
          return
        }
      }

      this.$emit('ruleChange')
    },
    onBlur (e, name, idx) {
      if (name === 'deposit_amount' && this.isNoShowPenalty) {
        const min = this.minDepositAmount
        const value = Number(e.target.value)

        if (isNaN(value) || value < min) {
          this.$set(this.cancelRule.rules[idx], name, min)
          this.$message && this.$message.warning(
            this.$t('api.optFields.noShowPenalty.error_minimum', {
              currency: this.formData.currency_code,
              amount: min
            })
          )
        }
      } else if (name === 'hour' && this.limitOne) {
        const value = Number(e.target.value)
        if (isNaN(value) || value < 1) {
          if (this.formData.setting.payment_mode === ProductPaymentMode.Onsite) {
            this.cancelRule.rules[0].hour = 0
            if (this.isClickingRadio) {
              this.isClickingRadio = false
              return
            }

            if (this.cancelRule.mode === CancelRuleMode.Hour) {
              this.cancelRule.mode = CancelRuleMode.BookingTime
              this.$message && this.$message.success(
                this.$t('api.product.fields.cancel_rule.switched_to_booking_time')
              )
            }
          }
        }
      } else if (e.target.value === '') {
        this.$set(this.cancelRule.rules[idx], name, 0)
      } else if (e.target.value < 0) {
        this.$set(this.cancelRule.rules[idx], name, 0)
      } else if (e.target.value > 100 && name === 'deposit_percent') {
        this.$set(this.cancelRule.rules[idx], name, 100)
      }
    },
    onChangeDeposit (v, d, name, idx) {
      this.$set(this.cancelRule.rules[idx], name, (v) ? 0 : undefined)
      let other = (name === 'deposit_percent') ? 'deposit_amount' : 'deposit_percent'
      let isOther = 'is_' + other
      if (!v && !this.cancelRule.rules[idx][isOther]) {
        this.$set(this.cancelRule.rules[idx], isOther, true)
        this.$set(this.cancelRule.rules[idx], other, 0)
      }
    }
  },
  watch: {
    'cancelRule.mode' (v, oldValue) {
      if (this.limitOne) {
        switch (v) {
          case CancelRuleMode.Day:
            if (this.cancelRule.rules[0]['day'] === undefined) {
              this.$set(this.cancelRule.rules[0], 'day', 0)
            }
            break
          case CancelRuleMode.Date:
            if (this.cancelRule.rules[0]['date'] === undefined) {
              this.$set(this.cancelRule.rules[0], 'date', this.$moment().format('YYYY-MM-DD'))
            }
            break
          case CancelRuleMode.Hour:
            let hour = Number(this.cancelRule.rules[0]['hour'])
            switch (oldValue) {
              case CancelRuleMode.Day:
              case CancelRuleMode.Date:
              case CancelRuleMode.BookingTime:
                if (isNaN(hour) || hour === 0) {
                  this.$set(this.cancelRule.rules[0], 'hour', 1)
                }
                break
              default:
                if (isNaN(hour) || hour === 0) {
                  this.cancelRule.mode = CancelRuleMode.BookingTime
                  this.$message && this.$message.success(
                    this.$t('api.product.fields.cancel_rule.switched_to_booking_time')
                  )
                }
            }
        }
      }
    },
    'isNoShowPenalty' (v) {
      let rule = this.cancelRule.rules[0]
      this.$set(rule, 'is_deposit_amount', !!v)
      this.$set(rule, 'is_deposit_percent', false)
      if (!rule.deposit_amount || rule.deposit_amount < this.minDepositAmount) {
        this.$set(rule, 'deposit_amount', this.minDepositAmount)
      }
    },
    'cancelRule': {
      handler: function (v) {
        this.onChange()
      },
      deep: true
    }
  }
}

</script>
